<form (ngSubmit)="add()" [formGroup]="form">
    <div style="width: 500px">
        <div class="title">Add server property</div>

        <app-alert/>

        <div class="label">Property name</div>
        <input autofocus class="field" formControlName="name" required type="text">

        <div class="label">Property value</div>
        <input autofocus class="field" formControlName="value" required type="text">

        <button [disabled]="!form.valid || isLoading" class="button" type="submit">
            <span [hidden]="isLoading">Submit</span>
            <img [hidden]="!isLoading" alt="Loading" src="../../../../assets/img/spinner.svg"/>
        </button>
    </div>
</form>